"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderIdentifier = exports.CustomerDisplayImageType = exports.PrinterSeries = exports.PrinterBrand = exports.TableNamingMethods = exports.PrinterType = exports.DeviceProfileStatus = exports.AppScreen = exports.SignatureAndTippingOption = exports.ReceiptPrintOption = exports.TableStatus = exports.TableShape = exports.EmailReceipt = exports.EmailType = exports.TipCalculation = exports.DayOfWeek = exports.RoundOffValue = exports.RoundOffOption = void 0;
var RoundOffOption;
(function (RoundOffOption) {
    RoundOffOption["ROUND_DOWN_TO_NEAR"] = "ROUND_DOWN_TO_NEAR";
    RoundOffOption["ROUND_UP_TO_NEAR"] = "ROUND_UP_TO_NEAR";
    RoundOffOption["ALWAYS_ROUND_DOWN_TO_NEAR"] = "ALWAYS_ROUND_DOWN_TO_NEAR";
    RoundOffOption["ALWAYS_ROUND_UP_TO_NEAR"] = "ALWAYS_ROUND_UP_TO_NEAR";
})(RoundOffOption = exports.RoundOffOption || (exports.RoundOffOption = {}));
var RoundOffValue;
(function (RoundOffValue) {
    RoundOffValue["ONE"] = "1";
    RoundOffValue["ZERO_POINT_FIVE"] = "0.5";
    RoundOffValue["ZERO_POINT_TWO_FIVE"] = "0.25";
    RoundOffValue["ZERO_POINT_ONE"] = "0.1";
    RoundOffValue["ZERO_POINT_ZERO_FIVE"] = "0.05";
})(RoundOffValue = exports.RoundOffValue || (exports.RoundOffValue = {}));
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["SUNDAY"] = "SUNDAY";
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["ALL"] = "ALL";
})(DayOfWeek = exports.DayOfWeek || (exports.DayOfWeek = {}));
var TipCalculation;
(function (TipCalculation) {
    TipCalculation["BEFORE_TAX"] = "BEFORE_TAX";
    TipCalculation["AFTER_TAX"] = "AFTER_TAX";
})(TipCalculation = exports.TipCalculation || (exports.TipCalculation = {}));
var EmailType;
(function (EmailType) {
    EmailType["DAILY_SALES_SUMMARY"] = "DAILY_SALES_SUMMARY";
    EmailType["LOW_INVENTORY_STOCK"] = "LOW_INVENTORY_STOCK";
    EmailType["PURCHASE_ORDER"] = "PURCHASE_ORDER";
    EmailType["PAYOUT_SUMMARY"] = "PAYOUT_SUMMARY";
    EmailType["SHIFT_SUMMARY"] = "SHIFT_SUMMARY";
})(EmailType = exports.EmailType || (exports.EmailType = {}));
var EmailReceipt;
(function (EmailReceipt) {
    EmailReceipt["NONE"] = "NONE";
    EmailReceipt["AUTO"] = "AUTO";
    EmailReceipt["MANUAL"] = "MANUAL";
})(EmailReceipt = exports.EmailReceipt || (exports.EmailReceipt = {}));
var TableShape;
(function (TableShape) {
    TableShape["RECTANGLE"] = "RECTANGLE";
    TableShape["SQUARE"] = "SQUARE";
    TableShape["ROUND"] = "ROUND";
})(TableShape = exports.TableShape || (exports.TableShape = {}));
var TableStatus;
(function (TableStatus) {
    TableStatus["YOUR_TABLE"] = "YOUR_TABLE";
    TableStatus["IN_USE"] = "IN_USE";
    TableStatus["SEATED"] = "SEATED";
    TableStatus["OCCUPIED"] = "OCCUPIED";
    TableStatus["DONE_SOON"] = "DONE_SOON";
    TableStatus["AVAILABLE"] = "AVAILABLE";
    TableStatus["INACTIVE"] = "INACTIVE";
    TableStatus["MULTI_USE"] = "MULTI_USE";
})(TableStatus = exports.TableStatus || (exports.TableStatus = {}));
var ReceiptPrintOption;
(function (ReceiptPrintOption) {
    ReceiptPrintOption["PROMPT"] = "PROMPT";
    ReceiptPrintOption["AUTO"] = "AUTO";
    ReceiptPrintOption["NO_PRINT"] = "NO_PRINT";
})(ReceiptPrintOption = exports.ReceiptPrintOption || (exports.ReceiptPrintOption = {}));
var SignatureAndTippingOption;
(function (SignatureAndTippingOption) {
    SignatureAndTippingOption["TIP_AND_SIGN_PAYMENT_SCREEN"] = "TIP_AND_SIGN_PAYMENT_SCREEN";
    SignatureAndTippingOption["TIP_AND_SIGN_PAYMENT_DEVICE"] = "TIP_AND_SIGN_PAYMENT_DEVICE";
    SignatureAndTippingOption["TIP_AND_SIGN_RECEIPT"] = "TIP_AND_SIGN_RECEIPT";
    SignatureAndTippingOption["NONE"] = "NONE";
})(SignatureAndTippingOption = exports.SignatureAndTippingOption || (exports.SignatureAndTippingOption = {}));
var AppScreen;
(function (AppScreen) {
    AppScreen["LOGIN"] = "LOGIN";
    AppScreen["ORDER_HISTORY"] = "ORDER_HISTORY";
    AppScreen["FLOOR_VIEW"] = "FLOOR_VIEW";
    AppScreen["NEW_ORDER"] = "NEW_ORDER";
    AppScreen["OPEN_ORDER"] = "OPEN_ORDER";
    AppScreen["ONLINE_ORDER"] = "ONLINE_ORDER";
})(AppScreen = exports.AppScreen || (exports.AppScreen = {}));
var DeviceProfileStatus;
(function (DeviceProfileStatus) {
    DeviceProfileStatus["ASSIGNED"] = "ASSIGNED";
    DeviceProfileStatus["UNASSIGNED"] = "UNASSIGNED";
})(DeviceProfileStatus = exports.DeviceProfileStatus || (exports.DeviceProfileStatus = {}));
var PrinterType;
(function (PrinterType) {
    PrinterType["BLUETOOTH"] = "BLUETOOTH";
    PrinterType["LAN"] = "LAN";
    PrinterType["WIFI"] = "WIFI";
    PrinterType["VIRTUAL"] = "VIRTUAL";
})(PrinterType = exports.PrinterType || (exports.PrinterType = {}));
var TableNamingMethods;
(function (TableNamingMethods) {
    TableNamingMethods["GENERATE_AUTOMATICALLY"] = "Generate Automatically";
    TableNamingMethods["CUSTOM"] = "Custom";
})(TableNamingMethods = exports.TableNamingMethods || (exports.TableNamingMethods = {}));
var PrinterBrand;
(function (PrinterBrand) {
    PrinterBrand["EPSON"] = "EPSON";
    PrinterBrand["EPSON_WEB"] = "EPSON_WEB";
    PrinterBrand["STAR"] = "STAR";
    PrinterBrand["OTHER"] = "OTHER";
})(PrinterBrand = exports.PrinterBrand || (exports.PrinterBrand = {}));
var PrinterSeries;
(function (PrinterSeries) {
    PrinterSeries["TM_M30"] = "TM_M30";
    PrinterSeries["TM_M30II"] = "TM_M30II";
    PrinterSeries["TM_U220"] = "TM_U220";
    PrinterSeries["TM_T82"] = "TM_T82";
    PrinterSeries["TM_L90"] = "TM_L90";
})(PrinterSeries = exports.PrinterSeries || (exports.PrinterSeries = {}));
var CustomerDisplayImageType;
(function (CustomerDisplayImageType) {
    CustomerDisplayImageType["orgLogo"] = "orgLogo";
    CustomerDisplayImageType["backgroundImage"] = "backgroundImage";
    CustomerDisplayImageType["promoImages"] = "promoImages";
})(CustomerDisplayImageType = exports.CustomerDisplayImageType || (exports.CustomerDisplayImageType = {}));
var OrderIdentifier;
(function (OrderIdentifier) {
    OrderIdentifier["TOKEN_ID"] = "TOKEN_ID";
    OrderIdentifier["CUSTOMER_NAME"] = "CUSTOMER_NAME";
})(OrderIdentifier = exports.OrderIdentifier || (exports.OrderIdentifier = {}));
//# sourceMappingURL=stores.js.map